import { Constants } from 'utils';

class AutoFillerForm extends HTMLElement {
	connectedCallback() {
		this.orderForm = this.closest('order-form');
		this.categorySelect = this.querySelector('select[name="category"]');
		this.submitButton = this.querySelector('[auto-fill-submit]');
		this.submitEventListener = this.onsubmit.bind(this);
		this.submitButton.addEventListener('click', this.submitEventListener);
		this.budgetRange = this.querySelector('budget-range');
		this.discounts = this.loadConfiguratorDiscounts();
	}
	disconnectedCallback() {
		this.submitButton.removeEventListener('click', this.submitEventListener);
	}
	loadConfiguratorDiscounts() {
		try {
			return JSON.parse(this.dataset.configuratorDiscounts || '[]');
		} catch (err) {
			console.error('Invalid JSON in configurator-discounts', err);
			return [];
		}
	}
	calcPriceBeforeDiscount(priceAfterDiscount) {
		// using the price before discount will make sure that customer invest the budget fully
		const discount = this.discounts
			.filter((discount) => discount.min_threshold <= this.budgetRange?.value)
			.sort((a, b) => a.discount_percent - b.discount_percent)
			.pop();
		const discountPercent = discount ? discount.discount_percent : 0;
		return Math.floor(priceAfterDiscount / (1 - discountPercent / 100));
	}
	onsubmit() {
		this.orderForm.dispatchEvent(
			new CustomEvent('order-form:randomize', {
				detail: {
					category: this.categorySelect.value || Constants.AUTO_FILLER_ALL,
					maxBudget: this.calcPriceBeforeDiscount(this.budgetRange?.value) || Infinity,
				},
			}),
		);
	}
}
customElements.define('auto-filler-form', AutoFillerForm);
